export function getColorByChainId(chainId?: number) {
  switch (chainId) {
    case 1:
      return "#59B3AE";
    case 10:
      return "#EB001A";
    case 137:
      return "#9567FF";
    default:
      return "#FFF";
  }
}
